export * from './panelSurface';
export {
  surfaceOutlineUv,
  surfaceOutlineFromDoc,
  surfaceOutlineContextFromDoc,
  outlineBounds,
  type SurfaceOutlineContext,
} from './surfaceOutline';
export { getRoomPolygon } from './roomPolygon';
export { pointInPolygon, clampPointToPolygon, clampBoxToRoom } from './polygonClamp';
export { footprintHalfXZ } from './footprint';
export {
  isSurfaceObstructed, anySurfaceVisible,
  type SurfacePlane, type Vec3Like,
} from './surfaceOcclusion';
export {
  defaultWindow, openingsOverlap, clampWindowOpening, containedInFrame,
  openingContainedInHost, translateOpening, tryMoveWindow,
} from './windowOpening';
export { defaultDoor, doorsOn } from './doorOpening';
export { panelsClearedOf, type PanelMove } from './panelsCleared';
export { mediaHostSurface, mediaSurfaceOptions } from './mediaSurface';
export {
  defaultDisplay, defaultTvOn, defaultProjector, defaultScreenWall,
  TV_CENTRE_HEIGHT_M, SCREEN_CENTRE_HEIGHT_M, DEFAULT_DROP_M,
} from './mediaDefaults';
export {
  surfacesAreParallel, projectPoseOntoSurface, poseWithinSurface,
  mirrorSurfaces, heightPeerSurfaces, poseToWorldPoint,
} from './surfaceMirror';
export {
  surfaceFootprints,
  type SurfaceFootprint, type SurfaceFootprintKind,
} from './surfaceFootprints';
export {
  surfaceSnapTargets,
  type SurfaceSnapTargets, type SurfaceSnapOptions,
} from './surfaceSnapTargets';
export {
  resolvePaste, resolvePasteSurface, clipboardPayloadFor, isSurfaceBound,
  anchorForObject, PASTE_CASCADE_M,
  type ClipboardPayload, type PasteAnchor, type PasteResult, type PasteRefusal,
} from './pasteTarget';
export { attachedSurfaces, ATTACH_TOLERANCE_M } from './surfaceAttachment';
